import { useEffect, useState } from 'react'

import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

type SettingsFooterProps = {
  children: React.ReactNode
  className?: string
  hidden?: boolean
}

export const SETTINGS_FOOTER_HEIGHT = 100

const SettingsFooter = ({ children, className, hidden }: SettingsFooterProps) => {
  const { isMobile } = useBreakpoint()
  const [isDisplayHidden, setIsDisplayHidden] = useState(Boolean(hidden))

  useEffect(() => {
    if (!hidden) setIsDisplayHidden(false)
  }, [hidden])

  return (
    <div
      onTransitionEnd={() => {
        if (hidden) setIsDisplayHidden(true)
      }}
      className={cn(
        'flex h-[100px] w-full flex-row border-t border-lightBorder bg-white transition-opacity duration-300',
        hidden ? 'pointer-events-none opacity-0' : 'opacity-100',
        isDisplayHidden && 'hidden',
        className,
        isMobile ? 'fixed bottom-0 left-0 right-0 z-10 px-5 py-4' : 'absolute bottom-0 left-0 right-0 z-10 px-10 py-4',
      )}
    >
      {children}
    </div>
  )
}

export default SettingsFooter
